import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, tap } from 'rxjs';
import { LoggerService } from '../services/logger.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard {
  private logger: LoggerService = new LoggerService(AuthenticationGuard.name);

  constructor(
    private _auth: AuthService,
    private _router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this._auth.isLoggedIn().pipe(
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          this.logger.info({
            message: 'Unauthenticated user redirecting to login',
            identifier: 'movacarpro_info_checking_if_user_is_authenticated',
            method: 'canActivate.tap.not.IsAuthenticated',
          });

          this._router.navigate(['/login']);

          return;
        }

        this.logger.info({
          message: 'Authenticated user accessing route',
          identifier: 'movacarpro_info_user_is_authenticated',
          method: 'canActivate.tap.IsAuthenticated',
        });
      }),
    );
  }
}
